import { ReactNode } from 'react';
import { useIntl } from 'react-intl';

import { useStyles } from './download-app.styles';
import { TabsContent } from './tabs/tabs-content';
import { ContentWrapper } from '../../../common/content-wrapper';

export const DownloadApp = () => {
  const benefits = [
    'downloadApp.benefit-1',
    'downloadApp.benefit-2',
    'downloadApp.benefit-3',
    'downloadApp.benefit-4',
  ];
  const classes = useStyles();
  const intl = useIntl();

  return (
    <ContentWrapper>
      <section
        className={classes.root}
        aria-label={intl.formatMessage({ id: 'downloadApp.ariaLabel' })}
      >
        <div className={classes.left}>
          <h2 className={classes.title} data-testid="download-title">
            {intl.formatMessage(
              { id: 'downloadApp.title' },
              { sup: (chunks: ReactNode) => <sup>{chunks}</sup> },
            )}
          </h2>
          <p className={classes.description}>{intl.formatMessage({ id: 'downloadApp.description' })}</p>
          <ul className={classes.list}>
            {benefits.map(item => {
              const content = item === 'downloadApp.benefit-4'
                ? intl.formatMessage({ id: item }, { span: (chunks: any) => <span className={classes.strong}>{chunks}</span> })
                : intl.formatMessage({ id: item });
              return (
                <li key={item} className={classes.item}>{content}</li>
              );
            })}
          </ul>
        </div>
        <TabsContent />
      </section>
    </ContentWrapper>
  );
};
